import { Component, EventEmitter, Input, OnInit, Output, ViewChild, ElementRef, ChangeDetectionStrategy } from "@angular/core";

import { BaseComponent, CheckoutService, environment, UserService } from "@mypxplat/xplat/core";
import { TranslateService } from "@ngx-translate/core";
import { AppService } from "@mypxplat/xplat/web/core";
import { UpgradeSoftwareStripeComponent } from "../modals";
import { ActivatedRoute, Router } from "@angular/router";

@Component({
  changeDetection: ChangeDetectionStrategy.Eager,
  selector: "myp-product-purchase-upgrade",
  templateUrl: "product-purchase-upgrade.component.html",
  standalone: false,
})
export class ProductPurchaseUpgradeComponent extends BaseComponent implements OnInit {
  @Input() homepage: boolean = false;
  @Input() couponParam: string;
  @Input() minimumProductPrice: number;
  public discountedMinimumProductPrice: number;
  isUpgrade: boolean = false;
  // Read by the template but never set, so the buttons always say "Buy now". Probably meant `isUpgrade`.
  isUpgrading: boolean;
  activeCurrency: any;
  displayCurrency: string;
  public appliedActiveOffer: any;

  public title: string = "newdash.studio_one_pro_seven_perpetual";
  constructor(
    public userService: UserService,
    public translate: TranslateService,
    public appService: AppService,
    public checkoutService: CheckoutService,
    public activatedRoute: ActivatedRoute,
    public router: Router
  ) {
    super(userService);
  }

  ngOnInit(): void {
    if (!this.checkoutService.upgradableStudioOneProducts) {
      this.checkoutService.getUpgradableProducts(true).subscribe((result: any) => {
        if (result && result.success && result.data) {
          this.process();
        }
      });
    } else {
      this.process();
    }
  }

  process() {
    this.userService.getActiveOffers().subscribe((result: any) => {
      let applies;
      if (result.data && result.data.length) {
        result.data.forEach((coupon) => {
          let appliesToProducts = coupon.applies_to_products.split(",");
          if (appliesToProducts.includes(this.checkoutService.upgradableStudioOneProducts?.data?.products[0].stripeProductId)) {
            applies = coupon;
          }
        });
      }
      this.activeCurrency = this.checkoutService.upgradableStudioOneProducts?.data?.geo["currency-code"];
      this.displayCurrency = this.activeCurrency;
      let prices: number[] = this.checkoutService.upgradableStudioOneProducts?.data?.prices.filter((p) => p.currency === this.activeCurrency.toLowerCase()).map((p) => p.unit_amount);
      if (!prices.length) {
        this.displayCurrency = "USD";
        prices = this.checkoutService.upgradableStudioOneProducts?.data?.prices.filter((p) => p.currency === "usd").map((p) => p.unit_amount);
      }
      this.isUpgrade = this.checkoutService.upgradableStudioOneProducts?.data?.products[0].title.indexOf("Upgrade") > -1;
      this.minimumProductPrice = this.isNoDecimalCurrency(this.activeCurrency) ? Math.min(...prices) : Math.min(...prices) / 100;
      if (applies) {
        this.discountedMinimumProductPrice = this.minimumProductPrice - (this.minimumProductPrice * applies?.percentage) / 100;
        this.appliedActiveOffer = applies;
      }
      if (this.isUpgrade) this.title = "newdash.studio_one_pro_seven_perpetual_upgrade";
    });
  }

  public isNoDecimalCurrency(currency) {
    if (currency) {
      return environment.stripe.no_decimal_currencies.includes(currency.toUpperCase());
    }
    return false;
  }

  showRegisterUpgradeProduct() {
    this.checkoutService.couponParam = this.couponParam;
    this.appService.goToCheckout(
      "/checkout?checkoutProductType=Perpetual",
      this.checkoutService.upgradableStudioOneProducts?.data?.products.length ? this.checkoutService.upgradableStudioOneProducts?.data?.products[0].id : null
    );
  }
}
